import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../../css/font.css";
import axios from "axios";
import { schoolFacultyurl, api } from '../../../apis/urls'
import { schoolsurl, facultyposlists, } from '../../../apis/urls'
import ReactPaginate from 'react-paginate';
import moment from "moment";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";

const FacultyList =()=> {

    const { pid } = useParams();
	let urole = localStorage.getItem('userrole')
	useEffect(() => {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        Listing();
        SchoolName();
        PositionListing();
    },[]
    );

    
	const [result,setResult] = useState([]);
    const [schName,setSchName] = useState([]);
    const [poName,setPoName] = useState('')
    const [search, setSearch]= useState('')
    const [searchTitle, setSearchTitle] = useState("");
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const[ pos,setPos ] = useState([]);
    const [fresult,setFresult] = useState([]);


    let counts = 0;
    if(result)
        {
            counts = result.length;
        }


	let navigate = useNavigate();


    const { id} = useParams();


    const Listing = () => {

		

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolFacultyurl+'/'+id+'?page='+0+'&size='+50,

            timeout: 1000000,

            headers: {'authorization': token}

          });

          
          instance.get('').then((response) =>{
            
            setResult(response?.data?.data?.items);
            setCurrentpage(response?.data?.data?.currentPage)
            setTotalPages(response?.data?.data?.totalPages)
            setTotalPages(response?.data?.data?.totalPages)
            setTotalItems(response?.data?.data?.totalItems)
            //console.log(response.data)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }

    const SchoolName = () => {

		

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolsurl+'/'+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setSchName(response?.data?.data);
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }

    const Deletefaculty = (fid) => {

        let r = window.confirm("Are you sure you want to delete this Faculty?");

        if(r == true){
            
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: schoolFacultyurl+'/'+id+'/'+fid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                Listing();
                navigate("/school_list/faculty/"+id)
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });
        }
    } 


    //PAGINATION


     // Invoke when user click to request another page.
     const handlePageClick = (event) => { console.log('EVENTSSS',event)

     const instance = axios.create({
         baseURL: schoolFacultyurl+'/'+id+'?page='+event.selected+'&size='+50,
         timeout: 1000000,
         headers: {'authorization': token}
       });

       

     instance.get('').then(res => {

        setResult(res.data.data.items)
     
    
     //console.log('paginatansresss',res.data.data)
     
         //setLoader(false);
     }).catch(e => {
     //console.log('errorshw',e);
     localStorage.removeItem('token')
     navigate("/")
     });


 };


    const refreshList = () => {
        setResult(null);
    };


    
    let token = "Bearer "+localStorage.getItem('token');
    const instances = axios.create({
        baseURL: api,
        timeout: 1000000,
        headers: {'authorization': token}
    });

    const findByTitles = name => {
        return instances.get('faculties/school/'+id+`?search=${name}&position=${poName}&status=ACTIVE`);
    };

    const onChangeSearchTitle = (e) => {
        const searchTitle = e.target.value;
        setSearch(e.target.value)
        setSearchTitle(searchTitle);
        findByTitles(searchTitle)
          .then(response => {
            setResult(response?.data?.data?.items);
            // console.log(response.data.data);
          })
          .catch(e => {
            console.log(e);
          });
    };

    const findByTitlesss = option => {
        return instances.get('faculties/school/'+id+`?position=${option}&search=${search}&status=ACTIVE`);
    };

    const onChangeSearchTitles = (e) => {
        const searchTitle = e.target.value;
        setPoName(e.target.value)
        findByTitlesss(searchTitle)
          .then(response => {
            setResult(response.data.data.items);
            // console.log(response.data.data);
          })
          .catch(e => {
            console.log(e);
          });
    };

    const [selected, setSelected] = useState([]);
    const [exports, setExports] = useState(false)
    const [exportvalue, setExportValue] = useState(false)
    const [allfiles, setAllFiles] = useState(true)
    const [sampleFile, setSampleFile] = useState('')

    // Export Athletic

    const exportAtletic  = () => { 

    //     let token = "Bearer "+localStorage.getItem('token');

        let token = "Bearer "+localStorage.getItem('token');

        const instance = axios.create({
            baseURL: api+"impex/faculty/faculty/"+id,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.get('').then((response) =>{
            setAllFiles(false)
            setExports(true)
            setExportValue(api+"impex/download/"+response.data.fileName)
            setSampleFile(api+"impex/download/sample_file.xlsx")

            // navigate(api+"impex/download/"+response.data.file)
            

        }).catch((error) =>{     
            console.log('error',error.message)  
        });
    }

    const dismissButton =()=>{
            setExports(false)
            setAllFiles(true)
            window.location.reload();
        
    }

    const PositionListing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: facultyposlists+'?page='+0+'&size='+200,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setFresult(response.data.data.items);
            console.log(response.data.data.items)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    } 

    var sl =1;
    return(
        <div>
        <aside class="right-side areas">
			<div class="content-area dash-contentss">
              <div class="page-title-wrpr">
                <div class="page-title-left-column">
                    <i class="icon-library1"></i>
                    <h2 class="page-title">Admin/Staff</h2>
                </div>
                <div class="page-rightside-action-column">
                <div class="input-groups mt-3 mb-3 search-grp">
                    <div class="input-group-prepends">
                    <select class="form-controls custom-select" onChange={onChangeSearchTitles}>
                        <option value="" selected disabled hidden>Select Position</option>
                        <option value="">ALL</option>
                        {
                            fresult?.map((item, index) => (
                                <option key={index} value={item.id}>{item.name}</option>
                            ))
                        }
                        {/* <option>ACTIVE</option>
                        <option>INACTIVE</option>
                        <option>DELETE</option> */}

                        </select> 
                    </div>
                    <input type="text" 
                    class="form-controls search-bar"             
                    value={searchTitle}
                    onChange={onChangeSearchTitle}
                    placeholder="Search" />
                    <button  class="btn btn-search icon-search"></button>
                    </div>
                    <Link to={"/add_faculty/"+id} data-toggle="tooltip" title="" className="addbtnitem-link text-anchor" data-original-title="Add New Admin/Staff"><i className="icon-add"></i><span>Add New Admin/Staff    </span> </Link>
                </div>
            </div>
            
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                    {
						urole === 'SUPERADMIN'?
						(<li class="breadcrumb-item"><Link to="/school_list">{decode(schName.name)}</Link></li>)
						:null
					}

                
                <li class="breadcrumb-item active" aria-current="page">Admin/Staff</li>
              </ol>
            </nav>
            {result &&
            <div class="number-of">
                Displaying  1-{counts} of {totalItems} results.
            </div>
            }
            {allfiles=== true?
            <div class="faculty-list-wrpr list-wrpr"> 


            {
					result?.map((item,index)=> 
                        

                        {

                            
                            
                            return(

                <div class="list faculty" key={index}>

                    <div class="row">
                    <div class="col-md-1">
                            <div class="faculty-user">Sl No.
                                <span class="desig">{sl++}</span>
                            </div>     
                            </div>
                        
                            {/* <div class="col-md-1">
                            <div class="faculty-user">Title
                                <span class="desig">{item.title}</span>
                            </div>     
                            </div> */}

                            <div class="col-md-3">
                            <div class="faculty-user">Name
                                <span class="desig">{decode(item.title+' '+item.first_name+' '+item.last_name)}</span>
                            </div>     
                            </div>

                            {/* {
					            pos?.map((item,index)=> ( */}

                                    {/* <div class="col-md-2">
                                    <div class="faculty-user">Position
                                        <span class="desig">{item.position_id}</span>
                                    </div>     
                                    </div> */}

                            {/* //     )) */}
                                
                            {/* // } */}
							
							<div class="col-md-3">
                            <div class="faculty-user">Email
                                <span style={{cursor: 'pointer'}} class="desig" onClick={() => window.location = 'mailto:'+item.email}>{item.email}</span>
                            </div>     
                            </div>
                            
                            <div class="col-md-2">
                            <div class="faculty-user">Title/Position
                           
                            {item.faculty_multiple_positions?.map((items,index)=>{
                                return(<span key={index} class="desig">{items?.faculty_position?.name}</span>)

                            })

                            

                            }
                               
                            </div>     
                            </div> 

                            <div class="col-md-2">
                            <div class="faculty-user">Last Updated
                                <span class="desig">{moment(item.updatedAt).format('LL')}</span>
                            </div>     
                            </div>
							
                        <div class="col-md-1">
                            <div class="list-action-wrpr text-right roundicons-text">
                                <Link  to={"/facultyview/"+id+"/"+item.id} title="View" ><i class="view icon-eye" style={{backgroundColor:'#eabb73'}} ></i ><span>View</span></Link>
                            </div>
                        </div>
                    </div>   
                </div>)

                
                        } 
                
                                    
                )
               
                
                }
                {result &&
                    <div class="number-of footer-number">
					    Displaying  1-{counts} of {totalItems} results.
				    </div>
                }

                {
                    !result?
                    (<div className="nodata">
                        <h2>Sorry! No Faculty Found</h2>
                    </div>):null
    
                } 
                {result &&
                <div class="row">
                    <div class="col-md-5 text-right"></div>
                    <div class="col-md-7 text-right">
                        <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={()=>{exportAtletic(selected)}}>Export</button>
                    </div>
                </div>
                }
                

                {result &&
                    <div class="pagination-wrpr">
                        <ReactPaginate
                                className="pagination page"
                                pageClassName="page-item"
                                activeClassName="active"
                                nextLabel=">"
                                previousLabel="<"
                                previousClassName="page-link p-link"
                                nextClassName="page-link p-link"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={10}
                                pageCount={totalPages}
                                renderOnZeroPageCount={1}
                            />
                    </div>
                }
                
                 
            </div>:null}       
        </div>

        {exports?
                    <div class="col-6 container  container-alert contianer-tab" style={{borderRadius:"10px", width:'60%'}}>
                    <div class="alert mb-5 py-4 container-alert" role="alert">
                        {/* <div class="d-flex container-alert"> */}
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg> */}
                            <div class="px-3">
                                <h2 class="alert-headings" style={{fontSize:"25px", textAlign:"center"}}>Thank you your data has been Exported!</h2><br/>
                                <button className="downloadExport">
                                    <a href={exportvalue}  onClick={dismissButton}>Download</a>
                                </button><span style={{width:"20px", padding:"20px"}}></span>    
                                <button onClick={dismissButton} className="downloadExport" data-dismiss="alert" aria-label="Close" data-abc="true">Dismiss</button> 
                            </div>
                        {/* </div> */}
                    </div>
                    </div>
                    :null
            }




        </aside>
    </div>
    );
}

export default FacultyList
